module.exports = __webpack_public_path__ + "static/media/vertex_exploded_GreatIcosahedron.e4b64d53.gif";